import { Action } from '@ngrx/store';
import { DispCoordinates } from 'src/app/shared/model/dispensary/dispensary-dsp.model';

export const OPEN_SEARCH_BAR = 'OPEN_SEARCH_BAR';
export const CLOSE_SEARCH_BAR = 'CLOSE_SEARCH_BAR';
export const CHANGE_MENU_ACTIVE = 'CHANGE_MENU_ACTIVE';
export const OPEN_FILTER_BAR = 'OPEN_FILTER_BAR';
export const CLOSE_FILTER_BAR = 'CLOSE_FILTER_BAR';
export const OPEN_SIGN_IN = 'OPEN_SIGN_IN';
export const CHANGE_DISPENSARY = 'CHANGE_DISPENSARY';
export const OPEN_ADD_ADDRESS_POPUP = 'OPEN_ADD_ADDRESS_POPUP';

export class OpenAddAddressPopup implements Action {
  readonly type = OPEN_ADD_ADDRESS_POPUP;
  constructor(
    public payload: {
      defaultCoordinates: DispCoordinates
    }
  ) {}
}

export class OpenSearchBar implements Action {
  readonly type = OPEN_SEARCH_BAR;
}

export class CloseSearchBar implements Action {
  readonly type = CLOSE_SEARCH_BAR;
}

export class OpenFilterBar implements Action {
  readonly type = OPEN_FILTER_BAR;
}

export class CloseFilterBar implements Action {
  readonly type = CLOSE_FILTER_BAR;
}

export class OpenSignIn implements Action {
  readonly type = OPEN_SIGN_IN;
}

export class ChangeMenuActive implements Action {
  readonly type = CHANGE_MENU_ACTIVE;
  constructor(
    public payload: {
      activeMenu: string
    }
  ) {}
}

export class ChangeDispensary implements Action {
  readonly type = CHANGE_DISPENSARY;
  constructor(
    public payload: {
      disp_id: string
    }
  ) {}
}
// tslint:disable-next-line:max-line-length
export type MenuActions = OpenAddAddressPopup | OpenSearchBar | CloseSearchBar | OpenFilterBar | CloseFilterBar | ChangeMenuActive | OpenSignIn | ChangeDispensary;
